import Api from '@sendsprint/api-types';
import Avatar from '@sendsprint/ui-react/dist/components/Avatar';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Flag from '@sendsprint/ui-react/dist/components/Flag';
import React from 'react';

interface Props {
  initials: string;
  country: Api.Model.CountryInitials;
}

const AvatarWithFlag = ({ country, initials }: Props) => {
  return (
    <Box className="ss-relative">
      <Avatar initials={initials} size={48} />
      <Box className="ss-absolute ss-bottom-0 ss--right-1">
        <Flag countryInitials={country} size={16} />
      </Box>
    </Box>
  );
};

export default AvatarWithFlag;
